import {Inject, Injectable} from '@angular/core';
import {DataRequirements, DataRequirementsInjectionToken} from '../data.requirements';
import {MonthlyTopicMapper} from '../mappers/monthly-topic.mapper';

@Injectable({
    providedIn: 'root'
})
export class GetMonthlyTopicUseCase {
    constructor(
        private mapper: MonthlyTopicMapper,
        @Inject(DataRequirementsInjectionToken) private data: DataRequirements
    ) {}

    run() {
        return this.data.getMonthlyTopic().pipe(this.mapper.map);
    }
}
